module.exports = __webpack_public_path__ + "img/refresh.979c97c7.svg";